import { queryOptions } from '@tanstack/react-query'
import { queryKeys } from '../keys'
import type { UnusedSkipTokenOptions } from '@tanstack/react-query'
import type { HTTPError } from 'ky'
import type { HttpErrorResponse } from '@/types/error'
import type { GetUserProfileResponse } from '@/types/user'
import type { Except } from 'type-fest'
import { userService } from '@/services'

export const getUserProfileQueryOptions = (
  options?: Except<
    UnusedSkipTokenOptions<
      GetUserProfileResponse,
      HTTPError<HttpErrorResponse>,
      GetUserProfileResponse,
      ReturnType<typeof queryKeys.user.profile>
    >,
    'queryKey' | 'queryFn'
  >,
) =>
  queryOptions({
    queryKey: queryKeys.user.profile(),
    queryFn: ({ signal }) => userService.getProfile({ signal }),
    ...options,
  })
